import React, {Component} from 'react'
import { observer } from 'mobx-react'
import LiqpayOverlay from "./ui/LiqpayOverlay";
import LiqpayUI from "./ui/LiqpayUI";
import LiqpayHeader from "./ui/LiqpayHeader";
import LiqpayModal from "./ui/LiqpayModal";
//import LiqpayModal from "./ui/LiqpayModal";
//import { observable } from 'mobx'

const WebApp = window.Telegram.WebApp;
//const user = WebApp.unsafeInitData.user;

@observer
class LiqpayGeneratorApp extends Component {
    render() {
        return (
            <div>
                <LiqpayModal/>
                <LiqpayOverlay/>
                <LiqpayHeader/>
                <LiqpayUI/>
            </div>
        )
    }
}

export default LiqpayGeneratorApp
